import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
// form
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  FormProvider,
  RHFTextField,
} from '../components/hook-form';
// @mui
import {
  Dialog,
  Slide,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Stack,
  Alert,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useAuth from '../hooks/useAuth';
import DIOText from '../components/DIOText';
// utils
import axios from '../utils/axios';

// ----------------------------------------------------------------------

const Transition = forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

NickNameGuard.propTypes = {
  children: PropTypes.node,
};

export default function NickNameGuard({ children }) {
  const { user, getUser } = useAuth();
  const [openNickNameDialog, setOpenNickNameDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const NickNameSchema = Yup.object().shape({
    nickname: Yup.string().required('닉네임을 입력하세요').test('len', '닉네임은 100자 이내로 입력해주세요', val => val.length < 100),
  });

  const defaultValues = {
    nickname: '',
  }

  const methods = useForm({
    resolver: yupResolver(NickNameSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    setError,
    formState: { errors },
  } = methods;

  const submit = async (data) => {
    try {
      setIsLoading(true);
      await axios.patch(
        '/api/crews/nickname/', 
        data,
      );
      enqueueSnackbar('저장되었습니다');
      getUser();
      setOpenNickNameDialog(false); // Close the dialog after successful submission
      setIsLoading(false);
    } catch(err) {
      setIsLoading(false);
      console.error(err);
      setError('afterSubmit', { message: '저장에 실패하였습니다. 관리자에게 문의해주세요' }); 
      enqueueSnackbar('닉네임 저장에 실패하였습니다. 관리자에 문의해주세요', { variant: 'error' });
    }
  }

  useEffect(() => {
    if (user) {
      setOpenNickNameDialog((user?.crew) && !user?.crew?.nickname);
    }
  }, [user]);

  return (
    <>
      {children}
      <Dialog maxWidth="xs" fullWidth open={openNickNameDialog} TransitionComponent={Transition}>
        <DialogTitle paragraph>
          <DIOText /> 크루로 활동할 닉네임을 입력해주세요.
        </DialogTitle>
        <DialogContent>
          <DialogContentText paragraph>
            닉네임은 회사와의 소통에 사용되며, 프로필 페이지에서 변경이 가능합니다.
          </DialogContentText>
          <FormProvider methods={methods}>
            <Stack spacing={3}>
            {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
            <RHFTextField name="nickname" label="활동할 닉네임" placeholder="예. 테드" helperText="크루의 신상 보호를 위한 이름이에요" />
            </Stack>
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            variant="contained"
            onClick={handleSubmit(submit)}
            loading={isLoading}
          >
            저장하기
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
